import React from 'react';
import CropFreeIcon from '@mui/icons-material/CropFree';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@curves/ui-base';
import { FloatButton } from '@Local/Components';

/** 與 MeasurementReportPage 傳入的 reportLayout 一致 */
export const REPORT_MEASUREMENT_LAYOUT = {
    DEFAULT: 'default',
    FOCUS: 'focus',
};

/**
 * 報表頁專注模式切換鈕：置於日期列旁（不浮動），依 focusMode 切換進入／離開圖示。
 *
 * @param {boolean} focusMode
 * @param {() => void} onToggle
 */
const ReportFocusModeToggleButton = ({ focusMode = false, onToggle }) => {
    if (typeof onToggle !== 'function') {
        return null;
    }

    return (
        <Box className={'measurement-report-focus-toggle'}>
            <FloatButton
                tip={focusMode ? '離開專注模式' : '專注模式'}
                className={'report-focus-action float-button--inline'}
                onClick={onToggle}
            >
                {focusMode ? <CloseIcon htmlColor={'#fff'} /> : <CropFreeIcon htmlColor={'#fff'} />}
            </FloatButton>
        </Box>
    );
};

export default ReportFocusModeToggleButton;
